import addressFieldsConfig from '../../../../../../shared/config/addressFieldsConfig';

const addressConfig = [
  'city',
  'line1',
  'line2',
  'stateProvince',
  'postalCode',
];

const addressFormatter = (address) => {
  const newAddress = {};
  Object.keys(address).forEach((b) => {
    if (addressConfig.indexOf(b) !== -1 && !!address[b]) {
      newAddress[b] = address[b].slice(0, addressFieldsConfig[b].maxLength);
    } else {
      newAddress[b] = address[b];
    }
  });
  return newAddress;
};

export default addressFormatter;
